import React from "react";
import {
  ClaroModalCustom,
  ClaroCardSimple,
  ClaroImageBanner,
  ClaroTextGeneral,
  ClaroTextDetail,
  ClaroLinkButton,
  ClaroButton,
} from "@claropay/shared";

const ModalCloseModal = (props) => {
  return (
    <ClaroModalCustom isOpen={props.isOpen}>
      <ClaroCardSimple
        backgroundColor="#fff"
        height="auto"
        borderRadius={props.borderRadiusCard}
        padding={props.paddingCard}
        // minHeight='230px'
      >
        <section>
          <ClaroImageBanner
            imageModal
            margin={props.imageMargin ? props.imageMargin : "-43px 0 30px 0"}
          >
            <img
              onClick={props.onClickImg}
              width={props.widthImg}
              height={props.heightImg}
              src={props.srcImage}
            />
          </ClaroImageBanner>
          <div style={{margin: "-54px 25px 30px", position: "absolute", right: 0}} onClick={props.onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
              <path d="M5 5.5L19 19.5M19 5.5L5 19.5" stroke="#ACACAC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <ClaroTextGeneral
            textmodal1
            margin={props.marginTitle ? props.marginTitle : "0px 0 18px 0"}
            width="100%"
            Height="auto"
            padding="0px 0 0 0"
            fontSize={props.fontSizeTitle}
            fontFamily={props.fontFamilyTitle}
            fontWeight={props.fontWeightTitle ? props.fontWeightTitle : "700"}
            colorTextModal1={props.colorTextModal1}
          >
            {props.text}
          </ClaroTextGeneral>
          <ClaroTextDetail
            color={props.colorTextdetail ? props.colorTextdetail : "#838383"}
            fontSize={props.fontSizeDetail}
            fontFamily={props.fontFamilyTextdetail}
            textAlign="center"
            margin={
              props.marginTextDetail ? props.marginTextDetail : "0px 0 30px 0"
            }
            padding="0"
            height="auto"
          >
            {props.textdetail}
          </ClaroTextDetail>
          <ClaroButton
            border={props.borderButton ? props.borderButton : undefined}
            display="block"
            margin={props.marginButton ? props.marginButton : "0 auto 2vh auto"}
            backgroundColor={props.backgroundColorButton}
            width={props.widthButton ? props.widthButton : "61.111vw"}
            height={props.heightButton ? props.heightButton : "11.4667vw"}
            textAlign="center!important"
            lineHeight={
              props.lineHeightButton ? props.lineHeightButton : "11.5vw"
            }
            borderRadius={
              props.borderRadiusButton ? props.borderRadiusButton : "50px"
            }
            weight={props.fontWeightButton ? props.fontWeightButton : "700"}
            activeBackground={props.activeBackgroundButton}
            hoverBackground={props.hoverBackgroundButton}
            fontSize={props.fontSizeButton}
            color={props.colorButton}
            onClick={props.onclickModal}
            btnTelcel={props.btnTelcel || false}
            fontFamily={props.fontFamilyButton}
            padding={props.paddingButton ? props.paddingButton : undefined}
          >
            {props.buttontext}
          </ClaroButton>
          <ClaroLinkButton
            textSize={props.textSizeLinkButton}
            textColor={props.textColorLinkButton}
            btnBackground={props.btnBackgroundLinkButton}
            activeOpacity={props.activeOpacityLinkButton}
            textAlign={props.textAlignLinkButton}
            fontWeight={props.fontWeightLinkButton}
            textDecoration={props.textDecorationLinkButton}
            fontFamily={props.fontFamilyLinkButton}
            width={props.widthLinkButton}
            textTransform={props.textTransformLinkButton}
            onClick={props.onclickModal}
          >
            {props.textLink}
          </ClaroLinkButton>
        </section>
      </ClaroCardSimple>
    </ClaroModalCustom>
  );
};
export default ModalCloseModal;
